import { normalizeBoolean } from '@change/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_MEMBER_PHONE_COLLECTION = createFcmConfig('member_phone_collection', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
